import React, { ReactNode } from 'react';
import { FormattedMessage, useIntl } from '@futrli/localisation';

import Button from 'carbon-react/lib/components/button';
import Dialog from 'carbon-react/lib/components/dialog';
import Form from 'carbon-react/lib/components/form';
import Typography from 'carbon-react/lib/components/typography';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => void;
  titleText?: ReactNode;
  bodyText?: ReactNode;
}

export const DeleteItemModal = ({ isOpen, onClose, onDelete, titleText, bodyText }: Props) => {
  const intl = useIntl();
  return (
    <Dialog
      title={
        <Typography fontSize="14px" fontWeight="600" pb="4px">
          {titleText || <FormattedMessage id="reporting.delete_item" defaultMessage="Delete item" />}
        </Typography>
      }
      onCancel={onClose}
      open={isOpen}
      size="medium"
      contentPadding={{
        p: 0
      }}
      aria-label={intl.formatMessage({
        id: 'reporting.delete_dialog.aria_label',
        defaultMessage: 'Delete dialog'
      })}
    >
      <Form
        stickyFooter
        data-role="delete-item-modal-form"
        leftSideButtons={
          <Button onClick={onClose} size="small" buttonType="secondary">
            <FormattedMessage id="common.cancel" defaultMessage="Cancel" />
          </Button>
        }
        saveButton={
          <Button buttonType="primary" size="small" onClick={onDelete}>
            <FormattedMessage id="common.delete" defaultMessage="Delete" />
          </Button>
        }
        onSubmit={() => null}
      >
        <Typography px={3} py="20px" mb={0} fontSize="14px">
          {bodyText || (
            <FormattedMessage
              id="reporting.are_you_sure_to_delete"
              defaultMessage="Are you sure you want to delete this item?"
            />
          )}
        </Typography>
      </Form>
    </Dialog>
  );
};
